// Drive Haus Brand Configuration
// Centralized configuration for easy updates

export const BRAND_CONFIG = {
  // Brand Identity
  name: 'Drive Haus Isl',
  tagline: 'DRIVEN BY EXCELLENCE',
  
  // Logo - Official Drive Haus logo
  logo: '/assets/drive-haus-logo.png',
  
  // Contact Information - Official Drive Haus
  phone: '0309-5111185',
  whatsappDisplay: '0309-5111185',
  whatsappInternational: '923095111185',
  whatsapp: '923095111185', // Centralized WhatsApp number for all inquiries
  email: 'info@drivehaus.com',
  
  // Location - Official Drive Haus Islamabad
  address: null, // No specific street address provided
  city: 'Islamabad',
  state: null, // Not applicable for Pakistan
  zipCode: null, // Not applicable for Pakistan
  country: 'Pakistan',
  latitude: 33.6955556,
  longitude: 72.9895278,
  coordinatesDisplay: '33°41\'44.0"N 72°59\'22.3"E',
  googleMapsUrl: 'https://www.google.com/maps?q=33.6955556,72.9895278',
  
  // Business Hours
  hours: {
    weekdays: 'Mon-Fri: 9AM-6PM',
    saturday: 'Saturday: 10AM-4PM',
    sunday: 'Sunday: Closed'
  },
  
  // Social Media - Official Drive Haus
  social: {
    facebook: 'https://www.facebook.com/share/1DM88jovw6/?mibextid=wwXIfr',
    instagram: 'https://www.instagram.com/drivehaus185?stkn=MTJsNWFpMDZhcmUzbQ%3D%3D&utm_source=qr',
    tiktok: '@drivehaus185',
    twitter: '#',
    linkedin: '#'
  },
  
  // Currency
  currency: 'Rs.',
  currencyCode: 'PKR',
  
  // Financing Defaults (for lease calculator)
  financing: {
    defaultInterestRate: 0.05, // 5%
    defaultTerm: 36, // 36 months
    minDownPaymentPercent: 0.10, // 10%
    availableTerms: [12, 24, 36, 48, 60]
  },
  
  // Website
  baseUrl: process.env.PUBLIC_URL || '',
  githubPages: process.env.NODE_ENV === 'production' ? '/dream-vehicle-website' : ''
};

export const VEHICLE_TYPES = {
  SEDAN: 'Sedan',
  SUV: 'SUV',
  HATCHBACK: 'Hatchback',
  COUPE: 'Coupe',
  CONVERTIBLE: 'Convertible',
  WAGON: 'Wagon',
  TRUCK: 'Truck',
  VAN: 'Van',
  PICKUP: 'Pickup',
  CROSSOVER: 'Crossover',
  HYBRID: 'Hybrid',
  ELECTRIC: 'Electric'
};

export const PURCHASE_TYPES = {
  CASH: 'cash',
  LEASE: 'lease',
  BOTH: 'both'
};

export const TRANSMISSION_TYPES = {
  AUTOMATIC: 'Automatic',
  MANUAL: 'Manual',
  CVT: 'CVT',
  DCT: 'Dual-Clutch'
};

export const FUEL_TYPES = {
  PETROL: 'Petrol',
  DIESEL: 'Diesel',
  HYBRID: 'Hybrid',
  ELECTRIC: 'Electric',
  PLUGIN_HYBRID: 'Plug-in Hybrid'
};

export const CONDITION_TYPES = {
  NEW: 'New',
  USED: 'Used',
  CERTIFIED_PRE_OWNED: 'Certified Pre-Owned'
};

// Demo vehicles for initial showcase (clearly marked as demo)
export const DEMO_VEHICLES = [
  {
    id: 101,
    make: 'Suzuki',
    model: 'Alto',
    variant: 'VXR',
    year: 2023,
    price: 3500000,
    leasePrice: 75000,
    downPayment: 500000,
    leaseTerm: 36,
    purchaseType: 'both',
    mileage: 5000,
    transmission: 'Automatic',
    fuel: 'Petrol',
    engine: '660cc',
    bodyType: 'Hatchback',
    condition: 'New',
    color: 'White',
    featured: true,
    hotSelling: true,
    available: true,
    description: 'Suzuki Alto - The perfect city car with excellent fuel efficiency and modern features. Ideal for both cash purchase and lease options.',
    features: ['Power Steering', 'Air Conditioning', 'Power Windows', 'Central Locking', 'Security System', 'Front Fog Lights', 'Rear Wiper', 'Alloy Rims'],
    images: ['https://images.unsplash.com/photo-1590362891991-f776e747a588?w=800&h=600&fit=crop']
  },
  {
    id: 102,
    make: 'Toyota',
    model: 'Corolla',
    year: 2022,
    price: 25000,
    leasePrice: 350,
    purchaseType: 'both',
    mileage: 15000,
    transmission: 'Automatic',
    fuel: 'Hybrid',
    engine: '1.8L 4-Cylinder',
    bodyType: 'Sedan',
    condition: 'Used',
    featured: true,
    hotSelling: false,
    available: true,
    description: 'Reliable and fuel-efficient sedan, perfect for daily commuting.',
    features: ['Backup Camera', 'Bluetooth', 'Cruise Control', 'Keyless Entry'],
    images: ['https://images.unsplash.com/photo-1623869675781-80aa31012a5a?w=800&h=600&fit=crop']
  },
  {
    id: 103,
    make: 'Honda',
    model: 'Civic',
    year: 2023,
    price: 28000,
    leasePrice: 390,
    purchaseType: 'both',
    mileage: 8000,
    transmission: 'Automatic',
    fuel: 'Petrol',
    engine: '2.0L 4-Cylinder',
    bodyType: 'Sedan',
    condition: 'Used',
    featured: true,
    hotSelling: false,
    available: true,
    description: 'Sporty and modern sedan with excellent handling.',
    features: ['Apple CarPlay', 'Android Auto', 'Sunroof', 'Lane Assist'],
    images: ['https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=800&h=600&fit=crop']
  },
  {
    id: 104,
    make: 'Toyota',
    model: 'Yaris',
    year: 2022,
    price: 18000,
    leasePrice: 250,
    purchaseType: 'cash',
    mileage: 20000,
    transmission: 'Automatic',
    fuel: 'Petrol',
    engine: '1.5L 4-Cylinder',
    bodyType: 'Hatchback',
    condition: 'Used',
    featured: false,
    hotSelling: false,
    available: true,
    description: 'Compact and economical hatchback for city driving.',
    features: ['Touchscreen Display', 'Rear Camera', 'Bluetooth'],
    images: ['https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&h=600&fit=crop']
  },
  {
    id: 105,
    make: 'Hyundai',
    model: 'Tucson',
    year: 2023,
    price: 32000,
    leasePrice: 450,
    purchaseType: 'both',
    mileage: 12000,
    transmission: 'Automatic',
    fuel: 'Hybrid',
    engine: '1.6L Turbo',
    bodyType: 'SUV',
    condition: 'Used',
    featured: true,
    hotSelling: false,
    available: true,
    description: 'Versatile SUV with advanced safety features and hybrid efficiency.',
    features: ['All-Wheel Drive', 'Panoramic Sunroof', 'Wireless Charging', 'HDA'],
    images: ['https://images.unsplash.com/photo-1619682817481-e994891cd1f5?w=800&h=600&fit=crop']
  },
  {
    id: 106,
    make: 'Kia',
    model: 'Sportage',
    year: 2023,
    price: 30000,
    leasePrice: 420,
    purchaseType: 'both',
    mileage: 10000,
    transmission: 'Automatic',
    fuel: 'Hybrid',
    engine: '1.6L Turbo',
    bodyType: 'SUV',
    condition: 'Used',
    featured: false,
    hotSelling: false,
    available: true,
    description: 'Stylish SUV with modern tech and comfortable interior.',
    features: ['Harman Kardon Audio', 'Heated Seats', 'Navigation', 'Blind Spot Detection'],
    images: ['https://images.unsplash.com/photo-1606611013016-969c19ba27bb?w=800&h=600&fit=crop']
  },
  {
    id: 107,
    make: 'Toyota',
    model: 'Fortuner',
    year: 2022,
    price: 45000,
    leasePrice: 600,
    purchaseType: 'lease',
    mileage: 25000,
    transmission: 'Automatic',
    fuel: 'Diesel',
    engine: '2.8L Turbo Diesel',
    bodyType: 'SUV',
    condition: 'Used',
    featured: true,
    hotSelling: false,
    available: true,
    description: 'Rugged SUV perfect for adventure and family trips.',
    features: ['4WD', '7 Seats', 'Off-Road Mode', 'Tow Hitch'],
    images: ['https://images.unsplash.com/photo-1519245659620-e859806a8d3b?w=800&h=600&fit=crop']
  }
];

// Status types for vehicles, inquiries, test drives, and lease applications
export const VEHICLE_STATUS = {
  AVAILABLE: 'available',
  RESERVED: 'reserved',
  SOLD: 'sold',
  HIDDEN: 'hidden'
};

export const INQUIRY_STATUS = {
  NEW: 'new',
  CONTACTED: 'contacted',
  FOLLOW_UP: 'follow-up',
  CONVERTED: 'converted',
  CLOSED: 'closed'
};

export const TEST_DRIVE_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  NO_SHOW: 'no_show'
};

export const LEASE_STATUS = {
  NEW: 'new',
  UNDER_REVIEW: 'under_review',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  COMPLETED: 'completed'
};

// Vehicle features list for easy selection
export const VEHICLE_FEATURES = [
  'Air Conditioning',
  'Power Windows',
  'Power Locks',
  'ABS (Anti-lock Braking System)',
  'Airbags (Driver)',
  'Airbags (Passenger)',
  'Side Airbags',
  'Curtain Airbags',
  'Sunroof',
  'Panoramic Sunroof',
  'Navigation System',
  'GPS',
  'Parking Sensors',
  'Rear Camera',
  '360-degree Camera',
  'Cruise Control',
  'Adaptive Cruise Control',
  'Bluetooth',
  'Apple CarPlay',
  'Android Auto',
  'Wireless Charging',
  'USB Port',
  'Auxiliary Input',
  'Premium Audio System',
  'Harman Kardon Audio',
  'Bose Audio',
  'Alloy Wheels',
  'Leather Seats',
  'Heated Seats',
  'Ventilated Seats',
  'Memory Seats',
  'Power Seats',
  'Keyless Entry',
  'Push Button Start',
  'Remote Start',
  'Heated Steering Wheel',
  'Lane Assist',
  'Blind Spot Detection',
  'Forward Collision Warning',
  'Automatic Emergency Braking',
  'Adaptive Headlights',
  'LED Headlights',
  'HID Headlights',
  'Fog Lights',
  'Automatic Wipers',
  'Rain Sensing Wipers',
  'Auto Dimming Mirror',
  'HomeLink',
  'Towing Package',
  'Roof Rack',
  'Running Boards',
  'All-Wheel Drive',
  'Four-Wheel Drive',
  'Sport Mode',
  'Eco Mode',
  'Tow Hitch',
  'Trailer Brake Controller'
];
